import type { Tag as TagName } from '@/types/content'
import styles from './Tag.module.css'

/**
 * A category chip. Colour comes from a `data-tag` attribute so adding a new tag
 * means adding one CSS rule — no conditional logic here.
 */
export function Tag({ name, size = 'md' }: { name: TagName; size?: 'sm' | 'md' }) {
  return (
    <span className={styles.tag} data-tag={name} data-size={size}>
      {name}
    </span>
  )
}
